export default {
    en: {
        account_settings: "Account",
        change_password:"Change Password",
        current_password:"Current Password",

        update_password:"Update Password",
        plan:"Plan",
        remain_days:"({0} days left)",
        plan_terms:"{0} Terms",
        support:"Support",
        email_support:"Contact Us",
        delete_account:"Delete Account",
        logout:"Sign out",
        count_title:"Credits",
        storage_title:"Storage",


        delete_title:"Are you sure you want to delete your account?",
        delete_info1:"All personal information and account data will be permanently deleted.",
        delete_info2:"All your 3D models and optimization history will be lost.",
        delete_info3:"All remaining credits and benefits will expire.",
        delete_info4:"New member benefits will not be provided again upon re-registration.",
        delete_agree:"I have read and agree to the above terms.",
        delete_reason_title:"Reason for leaving (Required)",
        delete_reason_desc:"Please let us know what inconveniences you experienced so we can improve our service.",

        delete_warning:"This action cannot be undone. Please consider carefully.",

        delete_btn:"Delete Account",

        go_update_user_data_btn:"Account Settings",
        update_user_btn:"Update",
        update_account_title:"Account Settings",

        
        go_to_notice_btn:"Notice",
        go_to_faq_btn:"FAQ",
        go_to_policy_term_btn:"Terms & Privacy Policy",
        go_to_marketing_btn:"Marketing Preferences",

        account_user_name:"Name",
        account_user_email:"Email",
       
    },
    ko: {
        account_settings: "계정",
        change_password:"비밀번호 변경",
        current_password:"현재 비밀번호",

        update_password:"비밀번호 변경",
        plan:"플랜",
        remain_days:"({0}일 후 만료)",
        plan_terms:"{0} 정책",
        support:"문의",
        email_support:"이메일 문의",
        delete_account:"계정삭제",
        logout:"로그아웃",
        count_title:"크레딧",
        storage_title:"용량",


        delete_title:"계정을 정말 삭제하시겠어요?",
        delete_info1:"모든 개인정보와 계정 데이터가 영구적으로 삭제됩니다.",
        delete_info2:"작업한 모든 3D 모델과 최적화 기록이 사라집니다.",
        delete_info3:"남은 사용권과 혜택이 모두 소멸됩니다.",
        delete_info4:"재가입 시 신규회원 혜택은 중복 제공되지 않습니다.",
        delete_agree:"안내사항을 확인하였으며 동의합니다.",
        delete_reason_title:"서비스 탈퇴 사유(필수)",
        delete_reason_desc:"서비스를 이용하시면서 불편하셨던 점을 알려주시면 서비스 개선에 적극 반영하도록 하겠습니다.",

        delete_warning:"이 작업은 되돌릴 수 없습니다. 신중하게 결정해 주세요.",

        delete_btn:"계정 삭제",

        go_update_user_data_btn:"계정 정보 변경",
        update_user_btn:"변경하기",
        update_account_title:"개인정보 변경",

        
        go_to_notice_btn:"공지사항",
        go_to_faq_btn:"FAQ",
        go_to_policy_term_btn:"서비스 약관 및 정책",
        go_to_marketing_btn:"마케팅 수신 동의",

        account_user_name:"이름",
        account_user_email:"이메일",
    },
    ja: {
        account_settings: "アカウント",
        change_password:"パスワード変更",
        current_password:"現在のパスワード",

        update_password:"パスワード変更",
        plan:"プラン",
        remain_days:"({0}日後に期限切れ)",
        plan_terms:"{0} ポリシー",
        support:"문의",
        email_support:"お問い合わせ",
        delete_account:"アカウント削除",
        logout:"ログアウト",
        count_title:"クレジット",
        storage_title:"ストレージ",


        delete_title:"本当にアカウントを削除しますか?",
        delete_info1:"すべての個人情報とアカウントデータが完全に削除されます。",
        delete_info2:"作成したすべての3Dモデルと最適化履歴が消失します。",
        delete_info3:"残りの利用権と特典がすべて失効します。",
        delete_info4:"再登録時、新規会員特典は重複して提供されません。",
        delete_agree:"案内事項を確認し、同意します。",
        delete_reason_title:"サービス退会理由(必須)",
        delete_reason_desc:"サービスのご利用中にご不便だった点をお聞かせいただければ、サービス改善に積極的に反映させていただきます。",

        delete_warning:"この操作は取り消せません。慎重にご判断ください。",

        delete_btn:"アカウント削除",

        go_update_user_data_btn:"アカウント情報変更",
        update_user_btn:"変更する",
        update_account_title:"個人情報変更",

        
        go_to_notice_btn:"お知らせ",
        go_to_faq_btn:"FAQ",
        go_to_policy_term_btn:"サービス約款及び規約",
        go_to_marketing_btn:"マーケティング情報受信同意",

        account_user_name:"名前",
        account_user_email:"イメール",
    },
};
